import { Navigate } from "react-router";
import type { AppModule } from "../types";
import { s } from "./strings";

/** The clone never shows Clockify's Free-plan promo: scheduling is free here (routes.md redirects). */
function ToSchedule() {
  return <Navigate replace to="/scheduling#projects" />;
}

export const schedulingModule: AppModule = {
  name: "scheduling",
  routes: {
    shell: [
      {
        path: "/scheduling",
        handle: { title: s.title },
        lazy: () => import("./pages/SchedulePage").then((m) => ({ Component: m.SchedulePage })),
      },
      { path: "/promo/scheduling", element: <ToSchedule /> },
    ],
  },
  sidebar: [
    {
      id: "SCHEDULE",
      label: s.sidebar,
      path: "/scheduling#projects",
      icon: "schedule",
      alt: s.sidebarAlt,
      // Hidden while "Project and team scheduling" is off (spec section 2).
      visible: (ctx) => ctx.workspaceSettings.schedulingEnabled !== false,
    },
  ],
};
